<template>
  <el-form ref="_subForm" :class="isDetails() ? 'table-details' : ''" :model="formData" :rules="rules">
    <el-button type="primary" size="small" class='add-btn' @click="handleAdd" v-if="dynamicColumns.addBtn&&!isDetails()">{{ dynamicColumns.addText }}
    </el-button>
    <el-table :data="formData[subListKey] || []" :height="dynamicColumns.height" border>
      <template v-for="column in dynamicColumns.column">
        <el-table-column v-if="showColumn(column) && column.type === 'index'" :key="column.prop || column.type + '-' + column.label" type="index" :label="column.label" :width="column.width" align="center" />
        <el-table-column v-else-if="showColumn(column)" :key="column.prop" :prop="column.prop" :label="column.label" :width="column.width" align="center" :render-header="column.required ? renderHeaderStar : undefined">
          <template slot-scope="scope">
            <el-form-item :prop="subListKey + '.' + scope.$index + '.' + column.prop" :rules="getRule(column)">
              <template v-if="column.type === 'input'">
                <el-input v-model="scope.row[column.prop]" v-bind="column.bind || {}" :placeholder="`请输入${column.label}`" :disabled="column.disabled" @input="handleInput(column, scope)" @change="handleChange(column, scope)" />
              </template>
              <template v-if="column.type === 'textarea'">
                <el-input v-bind="column.bind || {}" type="textarea" :autosize="{ minRows:column.minRows|| 3, maxRows:column.maxRows|| 4 }" v-model="scope.row[column.prop]" :placeholder="`请输入${column.label}`" :disabled="column.disabled"
                  @input="handleInput(column, scope)" @change="handleChange(column, scope)" />
              </template>
              <template v-else-if="column.type === 'switch'">
                <el-switch v-model="scope.row[column.prop]" active-text="" inactive-text="" :active-value="1" :inactive-value="0">
                </el-switch>
              </template>
              <template v-else-if="column.type === 'select'">
                <el-select
                  v-model="scope.row[column.prop]"
                  v-bind="column.bind || {}"
                  :placeholder="`请选择${column.label}`"
                  :disabled="column.disabled"
                  clearable
                  :filterable="!!column.dicUrl || column.filterable"
                  :remote="isDicRemote(column)"
                  :remote-method="isDicRemote(column) ? (q) => fetchDicRemoteDebounced(column, q) : undefined"
                  :loading="!!dicLoading[column.prop]"
                  @visible-change="(v) => onDicSelectVisible(v, column)"
                  @change="handleChange(column, scope)"
                >
                  <el-option v-for="item in getOptions(column, scope.row)" :key="String(item.value)" :label="item.label" :value="column.dataType=='number'?Number(item.value):item.value" />
                </el-select>
              </template>
              <template v-else-if="column.type === 'date'">
                <el-date-picker v-model="scope.row[column.prop]" v-bind="column.bind || {}" :type="column.dateType || 'date'" :placeholder="`请选择${column.label}`" :disabled="column.disabled" @change="handleChange(column, scope)" />
              </template>
              <template v-else-if="column.type === 'custom-input'">
                <custom-input v-model="scope.row[column.prop]" v-bind="column.bind || {}" :precision="column.precision" @input="handleInput(column, scope)" @change="handleChange(column, scope)" />
              </template>
              <template v-else-if="column.type === 'autocomplete-reset'">
                <autocomplete-reset
                  v-model="scope.row[column.prop]"
                  v-bind="column.bind || {}"
                  :typeUse="column.typeUse"
                  :formData="scope.row"
                  @input="handleInput(column, scope)"
                  @change="handleChange(column, scope)"
                  @handleChange="handleChange(column, scope)"
                  @handleChanges="handleChange(column, scope)"
                />
              </template>
              <template v-else-if="column.type === 'updata-img'">
                <!-- 用flex实现按钮与图片左右布局，垂直居中对齐 -->
                <div class="upload-wrapper">
                  <!-- 上传按钮：替换为相机图标，去掉文字，改为图标按钮 -->
                  <el-upload  v-if="!isDetails()" class="image-uploader" :action="getUploadAction(column)" :headers="uploadHeaders" :show-file-list="false" :on-success="(res, file) => handleUploadSuccess(res, file, scope.row, column)" :before-upload="beforeUpload">
                    <i class="el-icon-folder-add"></i>
                  </el-upload>
                  <div class="image-box" v-if="scope.row[column.prop]">
                    <div class="image-item" v-for="(item,index) in getImgSrc(scope.row[column.prop],'list')" :key="index">
                      <el-image :src="item" :preview-src-list="getImgSrc(scope.row[column.prop],'list')" fit="cover" style="width: 60px; height: 60px"></el-image>
                      <!-- 删除按钮：悬浮在图片右上角 -->
                      <i v-if="!isDetails()" class="el-icon-circle-close delete-btn" @click.stop="handleDeleteImage(scope.row,column.prop,index)"></i>
                    </div>
                  </div>
                </div>
              </template>
            </el-form-item>
          </template>
        </el-table-column>
      </template>
      <el-table-column v-if="!isDetails()&&buttonConfig" fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-form-item>
            <el-button class="del-button" v-if="getDelBtn" @click="handleDel(scope.$index)" type="text" size="small">删除</el-button>
            <el-button v-if="getMenuButton" class="del-button" @click="dynamicColumns.menuButton.callBack(scope)" type="text" size="small">{{ optionConfig.menuButton.text }}</el-button>
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>
<script>

import { showItem } from '@/basic-common/util/common.js'
import request from '@/router/axios'
import { getToken } from '@/util/auth'
import website from '@/config/website'
/**
 * @desc 表单表格组件
 * @param formData 浅拷贝父组件对象，TODO：后期应改为v-model绑定
 * @param subListKey 子表数组在 formData 上的字段名，默认 list，须与 el-form 校验路径一致
 * @param rules 可单独定义验证规则传入  TODO：后期需要改为传入现有验证规则字符串
 * @param optionConfig { String } 要请求的地址 默认为承运商
 *-- @param type 为组件类型 支持部分 el组件 及 部分自定义组件， 传参参考对应文档用法
 *-- @param label  要显示的拼音码字段 默认carrierName
 *-- @param add，edit，view  控制不同类型表单显隐
 *-- @param disabled 等属性根据业务控制拿结果

 **/
export default {
  name: 'FormTable',
  props: {
    subListKey: {
      type: String,
      default: 'list'
    },
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    },
    optionConfig: {
      type: Object,
      default: () => {
        return {
          menuButton: false,
          column: [],
        }
      }
    },
    showItem: Function
  },
  computed: {
    dynamicColumns () {
      return {
        columnType: this.optionConfig.columnType,
        addBtn: true,
        delBtn: true,
        addText: '新增',
        height: '30vh',

        ...this.optionConfig,
        column: [
          ...this.optionConfig.column
        ].map(col => ({
          add: true,
          edit: true,
          view: true,
          disabled: false,
          type: 'input',
          dataType: 'number',
          props: {
            label: "dictValue",
            value: "dictKey",
          },
          ...col,
          bind: {
            maxlength: 30,
            ...col
          },
        }))
      }
    },
    buttonConfig () {
      return this.dynamicColumns.delBtn || this.optionConfig.menuButton
    },
    getMenuButton () {
      return this.optionConfig.menuButton
    },
    getDelBtn () {
      const config = {
        columnType: this.optionConfig.columnType,
        addBtn: true,
        delBtn: true,
        ...this.optionConfig,
      }
      return config.delBtn
    },
    uploadHeaders () {
      const token = getToken()
      if (!token) return {}
      return {
        Authorization: 'Bearer ' + token,
        [website.tokenHeader]: 'bearer ' + token
      }
    }
  },
  data () {
    return {
      /** dicUrl 接口解析后的原始行，按 column.prop 缓存 */
      urlDicLists: {},
      dicLoading: {},
      dicRemoteTimers: {},
    }
  },
  created () {
  },
  beforeDestroy () {
    Object.keys(this.dicRemoteTimers).forEach((k) => {
      clearTimeout(this.dicRemoteTimers[k])
    })
  },
  methods: {
    // 新增子表
    handleAdd () {
      const key = this.subListKey
      if (!this.formData[key]) {
        this.$set(this.formData, key, [])
      }
      this.formData[key].push({})
    },
    // 显示列判断
    showColumn (column) {
      return showItem({
        add: column.add,
        edit: column.edit,
        view: column.view
      }, this.dynamicColumns.columnType)
    },

    /** 接口返回统一解析为数组 */
    normalizeDicList (res) {
      const body = res && res.data
      if (!body) return []
      if (Array.isArray(body)) return body
      if (Array.isArray(body.data)) return body.data
      if (Array.isArray(body.records)) return body.records
      return []
    },
    /** 将 dicUrl 中的 {{key}} 替换为检索关键字 */
    buildDicUrl (column, key) {
      const url = column.dicUrl || ''
      if (url.indexOf('{{key}}') >= 0) {
        return url.split('{{key}}').join(encodeURIComponent(key == null ? '' : String(key)))
      }
      return url
    },
    isDicRemote (column) {
      if (!column || !column.dicUrl) return false
      return column.remote === true || String(column.dicUrl).indexOf('{{key}}') >= 0
    },
    fetchDicRemote (column, query) {
      if (!column.dicUrl) return Promise.resolve()
      const url = this.buildDicUrl(column, query)
      this.$set(this.dicLoading, column.prop, true)
      return request({ url, method: 'get' }).then((res) => {
        const list = this.normalizeDicList(res)
        this.$set(this.urlDicLists, column.prop, list)
      }).catch(() => {
        this.$set(this.urlDicLists, column.prop, [])
      }).finally(() => {
        this.$set(this.dicLoading, column.prop, false)
      })
    },
    fetchDicRemoteDebounced (column, query) {
      clearTimeout(this.dicRemoteTimers[column.prop])
      this.dicRemoteTimers[column.prop] = setTimeout(() => {
        this.fetchDicRemote(column, query)
      }, 300)
    },
    onDicSelectVisible (visible, column) {
      if (!visible || !column.dicUrl) return
      const cached = this.urlDicLists[column.prop]
      if (!cached || !cached.length) {
        this.fetchDicRemote(column, '')
      }
    },
    // 获取选项数据（字典映射 / dicUrl 请求）
    getOptions (column, scopeRow) {
      const { props } = column
      if (column.dicData) {
        return Array.isArray(column.dicData) ? column.dicData.map(item => ({
          label: item[props.label],
          value: item[props.value]
        })) : []
      }
      if (column.dicUrl) {
        const raw = this.urlDicLists[column.prop] || []
        let opts = raw.map(item => ({
          label: item[props.label],
          value: item[props.value]
        }))
        const echoField = column.echoLabelField
        if (scopeRow && echoField) {
          const v = scopeRow[column.prop]
          const echo = scopeRow[echoField]
          if (v !== undefined && v !== null && v !== '' && echo) {
            const has = opts.some((o) => String(o.value) === String(v))
            if (!has) opts = [{ label: echo, value: v }, ...opts]
          }
        }
        return opts
      }
      return []
    },

    // 获取验证规则
    getRule (column) {
      if (!column.required) return []
      const rule = {
        required: true,
        message: `请录入`,
        trigger: ['blur', 'change']
      }
      return [rule]
    },

    // 输入事件处理
    handleInput (column, scope) {
      // 触发外部事件
      this.$emit('field-input', {
        prop: column.prop,
        value: scope.row[column.prop],
        index: scope.$index,
        row: scope.row
      })
    },

    // 变更事件处理
    handleChange (column, scope) {
      if (column.unique && this.isDuplicateValue(column.prop, scope.row[column.prop], scope.$index)) {
        this.$message.warning(`${column.label}不允许重复`)
        this.$set(scope.row, column.prop, '')
        return
      }
      if (this.exceedsMaxValue(column, scope.row[column.prop])) {
        this.$message.warning(`${column.label}不能超过${column.max}`)
        this.$set(scope.row, column.prop, column.max)
        return
      }
      if (typeof column.change === 'function') {
        column.change(
          scope.row[column.prop],
          scope.row,
          this.getOptions(column, scope.row)
        )
      }
      this.$emit('formTableChange', {
        prop: column.prop,
        value: scope.row[column.prop],
        index: scope.$index,
        row: scope.row,
        column
      })
    },
    isDuplicateValue (prop, value, currentIndex) {
      if (!this.formData || !Array.isArray(this.formData[this.subListKey]) || !value) {
        return false
      }
      return this.formData[this.subListKey].some((row, index) => index !== currentIndex && row[prop] === value)
    },
    exceedsMaxValue (column, value) {
      if (value === undefined || value === null || value === '' || column.max === undefined || column.max === null) {
        return false
      }
      const numericValue = Number(value)
      const maxValue = Number(column.max)
      if (isNaN(numericValue) || isNaN(maxValue)) {
        return false
      }
      return numericValue > maxValue
    },
    renderHeaderStar (h, { column }) {
      return [
        h('span', { style: 'color: red' }, '*'),
        h('span', ' ' + column.label),
      ]
    },
    getValidate () {
      return new Promise((resolve) => {
        this.$refs._subForm.validate((valid,) => {
          resolve(valid)
        })
      })
    },
    getUploadAction (column) {
      const url = column && column.url ? column.url : ''
      if (!url) return ''
      if (/^https?:\/\//.test(url) || url.indexOf('/produce/') === 0) {
        return url
      }
      return '/produce' + (url.indexOf('/') === 0 ? url : '/' + url)
    },
    handleDel (index) {
      this.$confirm('此操作将永久删除该数据', '确定删除吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const arr = this.formData[this.subListKey]
        if (Array.isArray(arr)) {
          arr.splice(index, 1)
        }
      }).catch(() => {
      })
    },
    getImgSrc (srcStr, type = 'src') {
      let srcAll = []
      if (!srcStr) return type == 'src' ? '' : []
      srcAll = srcStr.split(',')
      if (type == 'src') {
        return srcAll[0]
      } else {
        return srcAll
      }
    },
    // 上传成功处理
    handleUploadSuccess (response, file, row, column) {
      // 后端返回格式为 { code: 200, success: true, data: "JSON字符串", msg: "上传成功" }
      // data 字段是包含 originalName, domain, link, name 的 JSON 字符串
      if (response.code === 200 && response.success) {
        try {
          // 解析 data 字符串为对象
          const dataObj = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
          // 获取图片链接
          const imageUrl = dataObj.link;

          // 如果该行已有图片，追加新图片链接（用逗号分隔）
          if (row[column.prop]) {
            this.$set(row, column.prop, row[column.prop] + ',' + imageUrl);
          } else {
            this.$set(row, column.prop, imageUrl);
          }

          this.$message.success(response.msg || '上传成功');
        } catch (error) {
          console.error('解析上传响应失败:', error);
          this.$message.error('上传响应解析失败');
        }
      } else {
        this.$message.error(response.msg || '上传失败');
      }
    },
    // 上传前校验
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('只能上传JPG/PNG格式的图片!');
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2MB!');
      }
      return isJPG && isLt2M;
    },

    // 删除图片
    handleDeleteImage (row, key, index) {
      const imgList = this.getImgSrc(row[key], 'list');
      if (imgList && imgList.length > 0) {
        // 删除指定索引的图片
        imgList.splice(index, 1);
        // 更新图片字符串，用逗号连接
        this.$set(row, key, imgList.join(','));
      }
    },
    // 是否是详情
    isDetails () {
      return this.dynamicColumns.columnType && this.dynamicColumns.columnType == 'view'
    },

  }
}
</script>
<style lang="scss" scoped>
.add-btn {
  margin: 8px 0;
}
.del-button {
  margin-top: -10px;
}
.table-details {
  margin-top: 15px;
}

/* 外层容器：flex布局实现左右排列，垂直居中 */
.upload-wrapper {
  display: flex;
  align-items: center;
  gap: 16px; /* 按钮与图片之间的间距 */
  .el-icon-folder-add {
    font-size: 28px;
    color: #5094fa;
  }
}

/* 上传按钮：调整尺寸，让图标按钮更协调 */
.upload-btn {
  width: 40px;
  height: 40px;
  padding: 0; /* 清除内边距，让图标居中 */
  border-radius: 4px;
}

/* 图片容器：相对定位，用于删除按钮悬浮 */
.image-box {
  display: flex;
  .image-item {
    position: relative;
    margin: 0 5px;
  }
}

/* 删除按钮：悬浮在图片右上角，半透明背景 */
.delete-btn {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: #ff4d4f;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
</style>
